define(function(require) {
	const tpl = require('civicsViews/send_email/templates/t_cpv_send_email.hbs');
	const rowView = require('civicsViews/send_email/v_itv_email');

  const IpsModelCollection = require('civicsBase/ipsModelCollection');
  const IpsModel = require('civicsBase/ipsModel');

	const ViewManager = require('civicsUtils/view_manager');
	const AvailableFeatures = require('civicsUtils/available_features');

	 return Marionette.CompositeView.extend({
	  template: tpl,
      childView: rowView,
	  childViewContainer: '.send-email-items',
		ui: {
			addEmailButton: '.add-email-button',
			cancelButton: '.cancel-button',
			sendEmailButton: '.send-email-button'
		},
		events: {
			'click @ui.addEmailButton': 'addEmailAddress',
			'click @ui.cancelButton': 'closeEmailModal',
			'click .bbm-btn-close': 'closeEmailModal',
			'click @ui.sendEmailButton': 'sendEmailClicked'
		},
		childEvents: {
			'email-item:remove': 'removeEmailAddress'
		},
		views:{},
		initialize: function(options) {
			this.config = options.config;
			this.collection = new IpsModelCollection();
			this.emailModel = options.emailModel;
      this.portletName = options.portletName;
      this.config.commonLabel = {};
      this.addLoggedUser = options.addLoggedUser; //if true, add the email address of the user logged as initial data.

      //setup the labels
      if (this.portletName && this.portletName.length > 0) {
        var localizationKey = this.portletName.toUpperCase();

        this.config.commonLabel = {
          'modal_title': i18n.t('CIVICS.'+ localizationKey + '.EMAIL.MODAL_TITLE'),
          'form_description': i18n.t('CIVICS.'+ localizationKey + '.EMAIL.FORM_DESCRIPTION'),
          'box_title': i18n.t('CIVICS.'+ localizationKey + '.EMAIL.BOX_TITLE'),
          'emailAddress_headerDesc': i18n.t('CIVICS.'+ localizationKey + '.EMAIL.EMAIL_ADDRESS'),
          'addEmail_buttonDesc': i18n.t('CIVICS.'+ localizationKey + '.EMAIL.ADD_EMAIL'),
          'sendEmail_buttonDesc': i18n.t('CIVICS.'+ localizationKey + '.EMAIL.SEND'),
        }
      }

			//TODOs if logged in add the contact email address by default;
      var initialModel = new IpsModel({
        id: 1,
        emailAddress: '',
		showDelete: true
      });

      this.collection.add(initialModel);
		},
		onShow: function() {
		},
		onRender: function() {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
		},
    childViewOptions:function(model, index){
        var self = this;
        return {}
    },
    addEmailAddress: function() {
      /*If user is logged in, populate the first row.*/
			if (this.saveFormData()) {
				var collectionCurrentIndex = (this.collection.length) ? this.collection.length : 0;
				/*create temporary model for email address only, will attached it later on the emailModel during sendEmail*/
				var newEmailModel  = new IpsModel({
					id: collectionCurrentIndex + 1,
					emailAddress: '',
					showDelete: true
				});

				this.collection.add(newEmailModel);
				this.render();
			}
    },
		saveFormData: function(){
			var self = this;
			var isValid = true;

			_.each(self.collection.models, function(model) {
				var view = self.children.findByModel(model);
				var data = view.getData(null);

				if(data && data.isValid){
					model.emailAddress = data.sendTo;
					model.set('emailAddress', data.sendTo);
				} else {
					isValid = false;
				}

			});

			return isValid;
		},
    closeEmailModal: function() {
      if (this.modalRegion) {
        this.modalRegion.hideModal();
      } else {
        this.destroy();
      }
    },
		sendEmailClicked: function(){
			var self = this;
			ViewManager.resetErrorMessages(this);
			ViewManager.loading(true);
			this.sendEmailPromise = $.Deferred();
			var isDataValid = this.saveFormData();
			if (isDataValid){
				this.sendEmail();
			} else {
				//if has error still resolve this ..
				self.sendEmailPromise.resolve();
			}

			$.when(self.sendEmailPromise)
			.done(function(){
				if(isDataValid){
					self.closeEmailModal();
				}
				ViewManager.loading(false);
			})
			.fail(function (response, status, xhrResponse) {
				ViewManager.loading(false);
			});

		},
    sendEmail: function() {
			var self = this;
			var promises = [];
			// on 2023.01 changes, Rename parameter emailAdress to emailAddresses and datatype string to List<string>
			// to make the call on service once
			if(AvailableFeatures.PaymentEmailReceipt()){
				var emailAddresses = [];
				var def = new $.Deferred();
				_.each(this.collection.models, (model) => {
					if (model.emailAddress && model.emailAddress.length > 0) {
						emailAddresses.push(model.emailAddress);
					}
				});

				this.emailModel.set('emailAddresses', emailAddresses);
				this.emailModel.save(null, {
					success: (model, response) => {
						 def.resolve();
					},
					error: (model, response, options) => {
						def.reject();
						ViewManager.errorToWindow(response, this);
						ViewManager.loading(false);
					},
				});
				promises.push(def);
			}else{
				_.each(this.collection.models, (model) => {
					if (model.emailAddress && model.emailAddress.length > 0) {
						var def = new $.Deferred();
						this.emailModel.set('emailAddress', model.emailAddress);
	
						this.emailModel.save(null, {
							success: (model, response) => {
								 def.resolve();
								 this.emailModel.set('emailAddress', '') //reset after.
							},
							error: (model, response, options) => {
								def.reject();
								this.emailModel.set('emailAddress', '') //reset after.
								ViewManager.errorToWindow(response, this);
								ViewManager.loading(false);
							},
						});
						promises.push(def);
					}
				});
			}

			$.when.apply($, promises).done(function (response, status, xhrResponse) {
				self.sendEmailPromise.resolve();
			}).fail(function (response, status, xhrResponse) {
				self.sendEmailPromise.reject();
			});
    },
		removeEmailAddress: function (childView) {
			this.collection.remove(this.collection.get({cid: childView.model.cid}));

			this.removeChildView(childView);
			childView.destroy();

		},
    getCurrentUser: function(){
			//TODOs
    },
    templateHelpers: function () {
      var self = this;
      return {
        modal_title: self.config.commonLabel.modal_title,
        form_description: self.config.commonLabel.form_description,
        box_title: self.config.commonLabel.box_title,
        emailAddress_headerDesc: self.config.commonLabel.emailAddress_headerDesc,
        addEmail_buttonDesc: self.config.commonLabel.addEmail_buttonDesc,
        sendEmail_buttonDesc: self.config.commonLabel.sendEmail_buttonDesc,
      };
    }
	});
});
